import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('dashboard', 'change-status-req', [
  'UPDATE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'put',
  slug: [
    'appointments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'change_status',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/change-status-req.js